import React from 'react'
import { ICommonProps } from '..'
import { ElementProps } from '../base/element'

export interface IHtmlComponent extends ICommonProps {
    type: 'html'
    html: string,
  }
  
  function createMarkup(html: string) {
    return { __html: html }
  }

export const Html = (props: ElementProps) => {
    const comp = props.comp as IHtmlComponent
    const m = props.mergeStyles({main: {}})

  return (
    <div {...m.main} {...props.events()} dangerouslySetInnerHTML={createMarkup(comp.html as string)} />
  )
}
